import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';
import { useParams } from 'react-router-dom';
import "./user.css"

const UserFriends = () => {
    const [userFriends, setUserFriends] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false)
    const [page, setPage] = useState(1)
    const [isFriend, setIsFriend] = useState(null)

    const { user } = useParams()

    useEffect(() => {
        const checkIsFriend = async () => {
            try {
                const response = await api.get(`/users/${user}/check`)
                if (response) {
                    setIsFriend(response.data)
                }
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }
        checkIsFriend()
    }, [user])

    useEffect(() => {
        const getUserFriends = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/users/${user}/friends`, { params: { page } });
                setUserFriends(response.data.friends);

                if (response.data.friends.length < 20) {
                    setHasMore(false)
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch friends");
            } finally {
                setIsLoading(false);
            }
        };

        getUserFriends();
    }, [page, user]);

    const handleRefresh = async () => {
        setPage(1)
        setUserFriends([])
    }

    const sendFriendRequest = async (id) => {
        try {
            const response = await api.post()
        } catch (error) {

        }
    }
    const sendUnfriendRequest = async (id) => {
        try {
            console.log(id)
        } catch (error) {

        }
    }

    return (
        <div className='users-page-container'>
            <div className="userfriends-header">
                <h3>Friends</h3>
                {isFriend && <button className="add-frd-btn" onClick={() => sendUnfriendRequest(user)}>Remove Friend</button>}
                {!isFriend && <button className="add-frd-btn" onClick={() => sendFriendRequest(user)}>add Friend</button>}
            </div>
            <InfiniteScroll
                dataLength={userFriends.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                Loader={<Loader />}
                pullDownToRefresh={true}
            >
                <div className="friends-list">
                    {
                        isLoading && <Loader />
                    }
                    {!isLoading && userFriends.length === 0 &&
                        <p className="not-found-msg">No friends found</p>
                    }
                    {
                        userFriends && userFriends.map((frd) => (
                            <UserCard user={frd} />
                        ))
                    }
                </div>
            </InfiniteScroll>
        </div>
    );
};

export default UserFriends;
